/**
 * Beställare2Section - Formulär för andra beställare
 * 
 * Redigerbar sektion som kopieras från bokning vid första skapandet,
 * sedan oberoende av bokningsdatan.
 */

import React from 'react';

const Beställare2Section = ({ data, onChange, onBlur, expanded, onToggle, showRegisterButton, onRegister, isRegistered, saving }) => {
  return (
    <div className="bg-gray-50 rounded-lg shadow-sm border border-gray-200">
      {/* Header med expand/collapse */}
      <div 
        className="bg-gray-100 px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200 cursor-pointer hover:bg-gray-200 transition-colors"
        onClick={onToggle}
      >
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-leadme-gray-dark">Beställare 2</h2>
          <svg 
            className={`w-5 h-5 text-gray-500 transition-transform ${expanded ? 'rotate-180' : ''}`}
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
      
      {/* Content */}
      {expanded && (
        <div className="p-4 sm:p-6 space-y-4">
          {/* Info-banner */}
          <div className="text-sm text-gray-600 mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center">
              <svg className="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
              </svg>
              Redigerbar - kopieras från bokning vid första skapandet, sedan oberoende
            </div>
          </div>
          
          {/* Förnamn */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Förnamn *
            </label>
            <input
              type="text"
              value={data?.firstName || ''}
              onChange={(e) => onChange('firstName', e.target.value)}
              onBlur={onBlur}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-leadme-pink focus:border-leadme-pink"
            />
          </div>
          
          {/* Efternamn */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Efternamn *
            </label>
            <input
              type="text"
              value={data?.lastName || ''}
              onChange={(e) => onChange('lastName', e.target.value)}
              onBlur={onBlur}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-leadme-pink focus:border-leadme-pink"
            />
          </div>
          
          {/* Telefon */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Telefon
            </label>
            <input
              type="tel"
              value={data?.phone || ''}
              onChange={(e) => onChange('phone', e.target.value)}
              onBlur={onBlur}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-leadme-pink focus:border-leadme-pink"
            />
          </div>
          
          {/* E-post */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              E-post
            </label>
            <input
              type="email"
              value={data?.email || ''}
              onChange={(e) => onChange('email', e.target.value.replace(/\s+/g, ''))}
              onBlur={onBlur}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-leadme-pink focus:border-leadme-pink"
            />
          </div>

          {/* Skapa användare-knapp */}
          {showRegisterButton && !isRegistered && (
            <div className="pt-2 border-t border-gray-200">
              <p className="text-xs text-gray-500 mb-2">
                Estimatet är skickat men beställare 2 har inte skapats som användare ännu.
              </p>
              <button
                onClick={onRegister}
                disabled={saving || !data?.firstName?.trim() || !data?.lastName?.trim()}
                className="w-full px-4 py-2 text-sm bg-leadme-pink text-white rounded-lg hover:bg-leadme-pink-dark disabled:opacity-50 flex items-center justify-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
                Skapa användare
              </button>
            </div>
          )}
          {isRegistered && (
            <div className="pt-2 border-t border-gray-200">
              <p className="text-sm text-green-600 flex items-center gap-1">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Registrerad som användare
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Beställare2Section;

